// extracted by mini-css-extract-plugin
export default {"root":"Report-module-root","stats":"Report-module-stats","stat":"Report-module-stat","label":"Report-module-label","adInfo":"Report-module-adInfo"};